import { RatePlanService } from "../../services/RatePlanService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useRatePlansApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const ratePlanService = new RatePlanService(appConfig.apiBaseUrl);

    const findAllRatePlans = async (propertyId) => {
        return executeApiOperation(() => ratePlanService.findAll(propertyId));
    };

    const createRatePlan = async (propertyId, ratePlan) => {
        return executeApiOperation(() => ratePlanService.create(propertyId, ratePlan));
    };

    const updateRatePlan = async (propertyId, ratePlan) => {
        return executeApiOperation(() => ratePlanService.update(propertyId, ratePlan));
    };

    const deleteRatePlan = async (propertyId, ratePlanId) => {
        return executeApiOperation(() => ratePlanService.delete(propertyId, ratePlanId));
    };

    const createRestriction = async (propertyId, ratePlanId, restriction) => {
        return executeApiOperation(() => ratePlanService.createRestriction(propertyId, ratePlanId, restriction));
    };

    const updateRestriction = async (propertyId, ratePlanId, restrictionId, restriction) => {
        return executeApiOperation(() => ratePlanService.updateRestriction(propertyId, ratePlanId, restrictionId, restriction));
    };

    const updateRestrictions = async (propertyId, ratePlanId, restrictions) => {
        return executeApiOperation(() => ratePlanService.updateRestrictions(propertyId, ratePlanId, restrictions));
    };

    const deleteRestriction = async (propertyId, ratePlanId, restrictionId) => {
        return executeApiOperation(() => ratePlanService.deleteRestriction(propertyId, ratePlanId, restrictionId));
    };

    return {
        findAllRatePlans,
        createRatePlan,
        updateRatePlan,
        deleteRatePlan,
        createRestriction,
        updateRestriction,
        updateRestrictions,
        deleteRestriction,
    };
};
